import { defineComponent, computed, createElementBlock, createBlock, openBlock, renderSlot, withCtx, createVNode, normalizeClass, Fragment, renderList, createCommentVNode, createTextVNode, toDisplayString } from "vue";
import _sfc_main$3 from "../PrismicEmbed.vue.js";
import _sfc_main$2 from "../PrismicImage.vue.js";
import _sfc_main$1 from "../PrismicLink.vue.js";
const _hoisted_1 = ["dir"];
const _hoisted_2 = ["dir"];
const _hoisted_3 = ["dir"];
const _hoisted_4 = ["dir"];
const _hoisted_5 = ["dir"];
const _hoisted_6 = ["dir"];
const _hoisted_7 = ["dir"];
const _hoisted_8 = { key: 7 };
const _hoisted_9 = { key: 8 };
const _hoisted_10 = { key: 9 };
const _hoisted_11 = ["dir"];
const _hoisted_12 = ["dir"];
const _hoisted_13 = { key: 12 };
const _hoisted_14 = { key: 13 };
const _hoisted_15 = {
  key: 14,
  class: "block-img"
};
const _hoisted_16 = { key: 0 };
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{ name: "PrismicRichTextDefaultComponent" },
  __name: "PrismicRichTextDefaultComponent",
  props: {
    node: {},
    linkResolver: {}
  },
  setup(__props) {
    const props = __props;
    const dir = computed(() => {
      return "direction" in props.node && props.node.direction === "rtl" ? "rtl" : void 0;
    });
    return (_ctx, _cache) => {
      return _ctx.node.type === "heading1" ? (openBlock(), createElementBlock("h1", {
        key: 0,
        dir: dir.value
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 8, _hoisted_1)) : _ctx.node.type === "heading2" ? (openBlock(), createElementBlock("h2", {
        key: 1,
        dir: dir.value
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 8, _hoisted_2)) : _ctx.node.type === "heading3" ? (openBlock(), createElementBlock("h3", {
        key: 2,
        dir: dir.value
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 8, _hoisted_3)) : _ctx.node.type === "heading4" ? (openBlock(), createElementBlock("h4", {
        key: 3,
        dir: dir.value
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 8, _hoisted_4)) : _ctx.node.type === "heading5" ? (openBlock(), createElementBlock("h5", {
        key: 4,
        dir: dir.value
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 8, _hoisted_5)) : _ctx.node.type === "heading6" ? (openBlock(), createElementBlock("h6", {
        key: 5,
        dir: dir.value
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 8, _hoisted_6)) : _ctx.node.type === "paragraph" ? (openBlock(), createElementBlock("p", {
        key: 6,
        dir: dir.value
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 8, _hoisted_7)) : _ctx.node.type === "preformatted" ? (openBlock(), createElementBlock("pre", _hoisted_8, [
        renderSlot(_ctx.$slots, "default")
      ])) : _ctx.node.type === "strong" ? (openBlock(), createElementBlock("strong", _hoisted_9, [
        renderSlot(_ctx.$slots, "default")
      ])) : _ctx.node.type === "em" ? (openBlock(), createElementBlock("em", _hoisted_10, [
        renderSlot(_ctx.$slots, "default")
      ])) : _ctx.node.type === "list-item" ? (openBlock(), createElementBlock("li", {
        key: 10,
        dir: dir.value
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 8, _hoisted_11)) : _ctx.node.type === "o-list-item" ? (openBlock(), createElementBlock("li", {
        key: 11,
        dir: dir.value
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 8, _hoisted_12)) : _ctx.node.type === "group-list-item" ? (openBlock(), createElementBlock("ul", _hoisted_13, [
        renderSlot(_ctx.$slots, "default")
      ])) : _ctx.node.type === "group-o-list-item" ? (openBlock(), createElementBlock("ol", _hoisted_14, [
        renderSlot(_ctx.$slots, "default")
      ])) : _ctx.node.type === "image" ? (openBlock(), createElementBlock("p", _hoisted_15, [
        _ctx.node.linkTo ? (openBlock(), createBlock(_sfc_main$1, {
          key: 0,
          field: _ctx.node.linkTo
        }, {
          default: withCtx(() => [
            createVNode(_sfc_main$2, { field: _ctx.node }, null, 8, ["field"])
          ]),
          _: 1
        }, 8, ["field"])) : (openBlock(), createBlock(_sfc_main$2, {
          key: 1,
          field: _ctx.node
        }, null, 8, ["field"]))
      ])) : _ctx.node.type === "embed" ? (openBlock(), createBlock(_sfc_main$3, {
        key: 15,
        field: _ctx.node.oembed
      }, null, 8, ["field"])) : _ctx.node.type === "hyperlink" ? (openBlock(), createBlock(_sfc_main$1, {
        key: 16,
        field: _ctx.node.data,
        "link-resolver": _ctx.linkResolver
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["field", "link-resolver"])) : _ctx.node.type === "label" ? (openBlock(), createElementBlock("span", {
        key: 17,
        class: normalizeClass(_ctx.node.data.label)
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 2)) : (openBlock(true), createElementBlock(Fragment, { key: 18 }, renderList(_ctx.node.text.split("\n"), (line, index) => {
        return openBlock(), createElementBlock(Fragment, { key: line }, [
          index > 0 ? (openBlock(), createElementBlock("br", _hoisted_16)) : createCommentVNode("", true),
          createTextVNode(toDisplayString(line), 1)
        ], 64);
      }), 128));
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=PrismicRichTextDefaultComponent.vue.js.map
